module.exports = __webpack_public_path__ + "img/ec-phev-text.ac980159.png";